module.exports = __webpack_public_path__ + "static/media/hero-background.06249c2e.webp";